import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import * as R from 'ramda';

import Button from './Button';

class ButtonIcon extends PureComponent {
  static propTypes = {
    /**
     * One of material-icons: https://material.io/icons/
     */
    icon: PropTypes.string.isRequired,

    /**
     * style class to be applied on the icon only (not applied to the container)
     */
    iconClassName: PropTypes.string,

    /**
     * style class to be passed to the Button component along with 'core_icon'
     */
    className: PropTypes.string,

    /**
     * Any properties passed on the i13nModel prop will overwrite the
     * corresponding default property, as in the Button component. Label will
     * default to 'Icon button' if not passed in here or with an i13nLabel.
     */
    i13nModel: PropTypes.object,
    /**
     * Any other props are passed directly down to the Button component
     */
  };

  static defaultProps = {
    iconClassName: '',
    className: 'core_icon',
    testid: 'icon',
  };

  render() {
    const { className, iconClassName, icon } = this.props;

    const i13nModel = R.merge({ label: 'Icon button' }, this.props.i13nModel);

    const buttonProps = R.omit(['className', 'icon', 'iconClassName', 'i13nModel'], this.props);

    return (
      <Button size="no-miw" className={className} i13nModel={i13nModel} {...buttonProps}>
        <i className={`${iconClassName} icon material-icons`}>{icon}</i>
      </Button>
    );
  }
}

export default ButtonIcon;
